import { useState } from 'react';
import { styled } from 'styled-components';

import type { GroupedDevice } from '../../store/store';

import { ColorIcon } from './ColorIcon';
import { DeviceImage } from './DeviceImage';

const Wrapper = styled.div``;

const Title = styled.h2`
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  padding-top: 8px;
`;

const InnerWrapper = styled.div`
  padding: 16px;
  border: 1px solid #d2e7d3;
  border-radius: 16px;
  position: relative;
`;

const ColorsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 8px;
`;

type Props = {
  device: GroupedDevice;
};

export const DeviceListItem = (props: Props) => {
  const { device } = props;

  const { colors, model } = device;

  const [color, setColor] = useState(colors[0]);
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => {
    setHover(true);
  };

  const onMouseLeave = () => {
    setHover(false);
  };

  return (
    <Wrapper>
      <InnerWrapper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <DeviceImage src={color?.imageUrl} $hover={hover} />
        {colors.length > 1 ? (
          <ColorsWrapper>
            {colors.map((item) => (
              <ColorIcon color={item} onClick={setColor} selected={item === color} />
            ))}
          </ColorsWrapper>
        ) : null}
      </InnerWrapper>
      <Title>{model}</Title>
    </Wrapper>
  );
};
